module.exports = __webpack_public_path__ + "static/media/es.afff2473.svg";